import { Breadcrumb as ChakraBreadcrumb } from "@chakra-ui/react";
import type { ComponentProps, PropsWithChildren } from "react";
import type { BreadcrumbItemSharedProps } from "./BreadcrumbItem.props";

export default function BreadcrumbItem(
  props: BreadcrumbItemProps
): JSX.Element {
  const { isCurrentPage: _isCurrentPage, ...rest } = props;
  return <ChakraBreadcrumb.Item {...rest} />;
}

type ChakraBreadcrumbItemProps = ComponentProps<typeof ChakraBreadcrumb.Item>;

export type BreadcrumbItemProps = PropsWithChildren<
  BreadcrumbItemSharedProps & ChakraBreadcrumbItemProps
>;
